var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row"},[_c('button',{class:_vm.buttonMsg + '-action',on:{"click":function($event){return _vm.followUnfollowStrategy()}}},[_vm._v(" "+_vm._s(_vm.buttonMsg)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }